<template>
    <b-modal
      :id="modalId"
      :title="title"
      size="lg"
      centered
      header-class="border-0 modal-header-custom"
      body-class="p-0"
      content-class="rounded-lg shadow-lg"
      hide-footer
    >
      <template #modal-header="{ close }">
        <h4 class="modal-title">
          <i class="fa fa-flask mr-3"></i>
          {{ title }}
        </h4>
        <button class="close-button" @click="close()">
          <i class="fa fa-times"></i>
        </button>
      </template>
  
      <div class="modal-body-custom">
        <div class="normative-items">
          <!-- Benceno -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-flask chemical-icon"></i>
                  Benceno
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 1274 de 1997</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Asbesto -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-warning chemical-icon"></i>
                  Asbesto
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Ley 1968 de 2019</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Plomo -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-dot-circle-o chemical-icon"></i>
                  Plomo
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Ley 2041 de 2020</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Sílice Cristalina -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-cube chemical-icon"></i>
                  Sílice Cristalina Cristobalita
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Resolución 2467 de 2022</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Resolución 2400 de 1979</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>OSHA 29 CFR § 1910.1053</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Humos de soldadura -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-cloud chemical-icon"></i>
                  Humos de soldadura
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 1477 de 2014</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 2090 de 2003</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Formaldehído -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-flask chemical-icon"></i>
                  Formaldehído
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Resolución 2827 de 2006</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 1477 de 2014</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Cromo VI -->
          <div class="normative-item">
            <div class="content-wrapper">
              <div class="normative-header">
                <h5>
                  <i class="fa fa-diamond chemical-icon"></i>
                  Cromo VI
                </h5>
              </div>
              <div class="normative-content">
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Resolución 2400 DE 1979</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 1477 de 2014</p>
                </div>
                <div class="decree-item">
                  <i class="fa fa-file-text-o"></i>
                  <p>Decreto 2090 de 2003</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="modal-footer-custom">
        <b-button variant="primary" @click="$bvModal.hide(modalId)" class="close-btn">
          <i class="fa fa-times-circle mr-2"></i>
          Cerrar
        </b-button>
      </div>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'NormativeModal',
    props: {
      modalId: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: 'Componentes Químicos Regulados'
      }
    }
  }
  </script>
  
  <style scoped>
  
  .modal-header-custom {
    background: #ffffff;
    color: #1B212E;
    padding: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .modal-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
  }
  
  .close-button {
    background: transparent;
    border: none;
    color: #1B212E;
    font-size: 1.25rem;
    padding: 0.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .close-button:hover {
    color: #0FBEF9;
  }
  
  .modal-body-custom {
    padding: 2rem;
    max-height: 75vh;
    overflow-y: auto;
  }
  
  .normative-items {
    display: grid;
    gap: 1.25rem;
  }
  
  .normative-item {
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;
    overflow: hidden;
  }
  
  .normative-item:hover {
    border-color: #0FBEF9;
    box-shadow: 0 4px 12px rgba(15, 190, 249, 0.1);
    transform: translateY(-2px);
  }
  
  .content-wrapper {
    width: 100%;
  }
  
  .normative-header {
    padding: 1.25rem;
    background: rgba(15, 190, 249, 0.03);
    border-bottom: 1px solid #e2e8f0;
  }
  
  .normative-header h5 {
    font-size: 1.15rem;
    font-weight: 600;
    margin: 0;
    color: #1B212E;
    display: flex;
    align-items: center;
  }
  
  .chemical-icon {
    margin-right: 0.75rem;
    color: #0FBEF9;
    font-size: 1.25rem;
  }
  
  .normative-content {
    padding: 1.25rem;
  }
  
  .decree-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
  }
  
  .decree-item i {
    color: #0FBEF9;
    margin-right: 0.75rem;
  }
  
  .decree-item p {
    margin: 0;
    color: #4B5563;
    font-size: 0.95rem;
    font-weight: 500;
  }
  
  .modal-footer-custom {
    padding: 1.5rem;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
  }
  
  .close-btn {
    background: #0FBEF9;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
  }
  
  .close-btn:hover {
    background: #0DA8DF;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(15, 190, 249, 0.2);
  }
  
  /* Custom scrollbar */
  .modal-body-custom::-webkit-scrollbar {
    width: 6px;
  }
  
  .modal-body-custom::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .modal-body-custom::-webkit-scrollbar-thumb {
    background: #0FBEF9;
    border-radius: 3px;
  }
  
  .modal-body-custom::-webkit-scrollbar-thumb:hover {
    background: #0DA8DF;
  }
  
  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .normative-item {
    animation: fadeIn 0.2s ease-out forwards;
  }
  </style>